import Vue from 'vue'
const accessTokenKey = 'ShopAdmin-Token'
const saltTokenKey = 'Salt-Token'
const sellerInfoKey = 'Seller-Info'
const shopInfoKey = 'Shop-Info'
const merchantInfoKey = 'merchant-Info'

export default {
	getAccessToken () {
        return Vue.prototype.$cookies.get(accessTokenKey)
		// return localStorage.getItem(accessTokenKey)
	},
	setAccessToken (token) {
        return Vue.prototype.$cookies.set(accessTokenKey, token)
		// return localStorage.setItem(accessTokenKey, token)
	},
	removeAccessToken () {
        return Vue.prototype.$cookies.remove(accessTokenKey)
		// return localStorage.removeItem(accessTokenKey)
	},
	getSaltTokenToken () {
		// return localStorage.getItem(saltTokenKey) || '2343242342343243432'
		return Vue.prototype.$cookies.get(saltTokenKey) || '2343242342343243432'
	},
	setSaltTokenToken (token) {
		// return localStorage.setItem(saltTokenKey, token)
        return Vue.prototype.$cookies.set(saltTokenKey, token)
	},
	removeSaltTokenToken () {
        return Vue.prototype.$cookies.remove(saltTokenKey)
		// return localStorage.removeItem(saltTokenKey)
	},
	getSellerInfo () {
		return JSON.parse(localStorage.getItem(sellerInfoKey)) || {}
	},
	setSellerInfo (data) {
		return localStorage.setItem(sellerInfoKey, JSON.stringify(data))
	},
	getShopInfo () {
		return JSON.parse(localStorage.getItem(shopInfoKey)) || {}
	},
	setShopInfo (data) {
		return localStorage.setItem(shopInfoKey, JSON.stringify(data))
	},
	getMerchantInfo () {
		return JSON.parse(localStorage.getItem(merchantInfoKey)) || {}
	},
	setMerchantInfo (data) {
		return localStorage.setItem(merchantInfoKey, JSON.stringify(data))
	}
}



// WEBPACK FOOTER //
// ./src/utils/auth.js